import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { InterfaceTypes } from '../../enums';
import { AutoComplete } from '..';
import { INTERFACE_TYPES } from '../../constants';

const InterfaceType = () => {
  const [selectedInterfaceType, setSelectedInterfaceType] = useState('');
  const {
    register,
    getValues,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useFormContext();

  const setInputs = (interfaceType: InterfaceTypes) => {
    const chatbotInputs = [
      {
        name: 'InputMessage',
        inputDescription: 'Your text',
        inputType: 'String',
        options: [],
      },
      {
        name: 'InputFile',
        inputDescription: 'Your File',
        inputType: 'File',
        options: [],
      },
      {
        name: 'DynamicFormResults',
        inputDescription: '',
        inputType: 'Dictionary',
        options: [],
      },
      {
        name: 'EmbedInputs',
        inputDescription: '',
        inputType: 'Dictionary',
        options: [],
      },
    ];
    const formInputs = [
      {
        name: 'Text',
        inputDescription: 'Your text',
        inputType: 'String',
        options: [],
      },
    ];
    if (interfaceType === InterfaceTypes.Form) {
      setValue('aiEngineConfig.inputs', formInputs);
    } else if (interfaceType === InterfaceTypes.Chatbot) {
      setValue('aiEngineConfig.inputs', chatbotInputs);
    }
  };

  const setOutcomes = (interfaceType: InterfaceTypes) => {
    const chatbotOutcomes = [
      {
        name: 'OutputMessage', //OutputMessage
        outcomeDescription: 'Your text',
        outcomeType: 'String',
        options: [],
      },
      {
        name: 'DynamicFormDefinitions',
        outcomeDescription: '',
        outcomeType: 'Dictionary',
        options: [],
      },
      {
        name: 'Options',
        outcomeDescription: 'Select an option',
        outcomeType: 'String',
        options: [],
      },
      {
        name: 'AutoInvokeIn',
        outcomeDescription: '',
        outcomeType: 'Integer',
        options: [],
      }
    ];
    const formOutcomes = [
      {
        name: 'Text',
        outcomeDescription: 'Your text',
        outcomeType: 'String',
        options: [],
      },
    ];
    if (interfaceType === InterfaceTypes.Form) {
      setValue('aiEngineConfig.outcomes', formOutcomes);
    } else if (interfaceType === InterfaceTypes.Chatbot) {
      setValue('aiEngineConfig.outcomes', chatbotOutcomes);
    }
  };

  const handleInterfaceChanged = (value) => {
    // console.log('value', value);
    const values = getValues();
    const interfaceType = value.name;
    // console.log('values', { values, interfaceType });
    if (interfaceType === InterfaceTypes.Form) {
    } else if (interfaceType === InterfaceTypes.Chatbot) {
      setValue('needsContext', true);
      setValue('longRunningInference', false);
    }
    setValue('interfaceType', interfaceType);
    setInputs(interfaceType);
    setOutcomes(interfaceType);
  };

  useEffect(() => {
    const interfaceType = INTERFACE_TYPES.find((item) => item.name === getValues('interfaceType'));

    if (interfaceType) {
      setSelectedInterfaceType(interfaceType);
    }
  }, []);

  return (
    <>
      <AutoComplete
        id="app-Interface-type-select"
        items={INTERFACE_TYPES}
        itemText="label"
        itemKey="id"
        labelText="Interface Type"
        placeHolderText="Select Interface Type"
        multiSelect={false}
        onChange={(value) => handleInterfaceChanged(value)}
        defaultValue={selectedInterfaceType}
      />
    </>
  );
};

export default InterfaceType;
